import BaseModelRequest from '../communicate/BaseModelRequest'
import {getToken} from '../services/authService'

export default class UserRequest extends BaseModelRequest {

  builderHeader () {
    const headers = super.builderHeader();
    headers.Authorization = 'Bearer ' + getToken();

    return headers;
  }

  getProfile() {

  }

  signUp(user) {
    const url = "register";
    return this.post(url,user);
  }

  updateProfile(data) {

  }

  forgotPassword(phone) {
    const url = "forgot_password";
    return this.post(url, phone);
  }


  verifyOTP(data) {

  }
}



// WEBPACK FOOTER //
// ./src/request/UserRequest.js